






















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import AvaliacaoRiscoApaStore from '../Store/AvaliacaoRiscoApaStore'

@Component
export default class AvaliacaoPreOperatoriaResumo extends Vue {
  @Prop({ type: String, default: 'Avaliação Pré-Operatória Antecipada Digital' }) titleCard!: string;

  get getAvaliacaoRiscoApaStore() {
    return getModule(AvaliacaoRiscoApaStore, this.$store)
  }
}
